export default __webpack_public_path__ + "static/media/solely_texture.0e84a648.jpg";